import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/debounceTime'
import 'rxjs/add/operator/distinctUntilChanged'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/switchMap'
import { Observable } from 'rxjs/Observable'
import * as App from '../../app'
import * as Flash from '../../components/flash-message'
import * as Form from '../../components/form'
import * as IsActive from '../../components/is_active'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import {ApplicationState} from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'

const onEnter = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Router.ON_ENTER)
  .filter(() => history.location.pathname.startsWith(Menu.INTEGRATIONS_URL_HOME))
  .mergeMap((action: Router.OnEnterAction) => ([Actions.fetchExistingSystems(
    store.getState().app.selectedCommunity), Actions.fetchAvailableSystems(
      store.getState().app.selectedCommunity)]),
)

const onSaveRequest = (
  action$: ReduxObservable.ActionsObservable<Form.SaveAction<any>>,
  store: Redux.Store<ApplicationState>,
) => action$.ofType(Actions.FormConstants[Form.SAVE])
    .map((action) => Actions.createOrUpdateSystem(store.getState()))

type AddSystemErrorEpic = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
  ) =>
  Observable<Form.SaveCompleteAction>
const addSystemError: AddSystemErrorEpic = (action$) =>
  action$.ofType(Request.integrationsApiErrorConstant(Constants.ADD_SYSTEM))
  .map((action) => {
    if (action.payload.error.response.statusMessage === 'invalidCredentials') {
      return Flash.showFlashError(Constants.PLEASE_VERIFY_YOUR_CREDENTIALS)
    } else if (action.payload.error.response.statusMessage === 'unsupportedSystem') {
      return Flash.showFlashError(Constants.UNSUPPORTED_SYSTEM)
    }
    return Flash.showFlashError(action.payload.error.message)
  })

type AddSystemSuccessEpic = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
) => Observable<Form.SaveCompleteAction | Form.ResetAction | Actions.ToggleModal>
const addSystemSuccess: AddSystemSuccessEpic = (action$, store) =>
  action$.ofType(Request.integrationsApiSuccessConstant(Constants.ADD_SYSTEM))
    .mergeMap((action: any) => {
      const baseActions: any[] = [
        Actions.FormActions[Form.SAVE_COMPLETE](),
        Actions.fetchExistingSystems(store.getState().app.selectedCommunity),
      ]
      if (action.payload.response.statusMessage === 'invalidCredentials') {
        return [Flash.showFlashError(Constants.PLEASE_VERIFY_YOUR_CREDENTIALS),
          Actions.fetchAvailableSystems(store.getState().app.selectedCommunity)]
        .concat(baseActions)
      }
      if (action.payload.response.statusMessage === 'updateIntegrationSuccess') {
        return [Flash.showFlashMessage(Constants.CREDENTIALS_UPDATED)].concat(baseActions)
      }
      return [Flash.showFlashMessage(Constants.SYSTEM_CREATED)].concat(baseActions)
  })

type UpdatedSystemEpic = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
) => Observable<Form.SaveCompleteAction | Form.ResetAction | Actions.ToggleModal>

const updateSystemSuccess: UpdatedSystemEpic = (action$, store) =>
  action$.ofType(Request.integrationsApiSuccessConstant(Constants.UPDATE_SYSTEM))
    .mergeMap((action: any) => {
      const baseActions: any[] = [
        Actions.FormActions[Form.SAVE_COMPLETE](),
        Actions.fetchExistingSystems(store.getState().app.selectedCommunity),
      ]
      if (action.payload.response.statusMessage === 'updateStatusFailure') {
        return [Flash.showFlashError(Constants.PLEASE_VERIFY_YOUR_CREDENTIALS)]
        }
      if (action.payload.response.statusMessage === 'updateIntegrationSuccess') {
        if (action.requestAction.options.payload.is_active) {
          return [Flash.showFlashMessage(Constants.SYSTEM_ACTIVATED)].concat(baseActions)
        }
        return [Flash.showFlashMessage(Constants.SYSTEM_SWITCHED_OFF)].concat(baseActions)
      }
    })

const updateSystemError: UpdatedSystemEpic = (action$, store) =>
action$.ofType(Request.integrationsApiErrorConstant(Constants.UPDATE_SYSTEM))
  .mergeMap((action: any) => {
    const baseActions: any[] = [
      Actions.FormActions[Form.SAVE_COMPLETE](),
      Actions.fetchExistingSystems(store.getState().app.selectedCommunity),
    ]
    if (action.payload.error.response.statusMessage === 'invalidCredentials') {
      return [Flash.showFlashError(Constants.PLEASE_VERIFY_YOUR_CREDENTIALS)].concat(baseActions)
      }
  })

export const epic = ReduxObservable.combineEpics(
    onEnter,
    addSystemError,
    addSystemSuccess,
    onSaveRequest,
    Form.validateForm('integrations', Actions.FormConstants, Actions.FormActions, Constants.FormValidators),
    Form.validateFormOnOpen('integrations', Actions.FormConstants, Actions.FormActions, Constants.FormValidators),
    IsActive.createStatusUpdateEpic(Constants.UPDATE_SYSTEM_INLINE, Actions.statusUpdate),
    updateSystemError,
    updateSystemSuccess,
)



// WEBPACK FOOTER //
// ./src/pages/integrations/epic.ts